import type { InitialBreakpoints, RotateBreakpoint } from "./theme.types";

const isRotateBreakpoint = (breakpoint: number | RotateBreakpoint): breakpoint is RotateBreakpoint => {
	if (typeof breakpoint === "object") {
		return true;
	}
	return false;
};

const isNumber = (value: unknown): value is number => typeof value === "number";

const kebabCase = (str: string) =>
	str
		.replace(/([a-z])([A-Z])/g, "$1-$2")
		.replace(/[\s_]+/g, "-")
		.toLowerCase();

interface Breakpoint {
	name: string;
	value: number;
}

export function generateBreakpoints(initialBreakpoints: InitialBreakpoints) {
	const devices = Object.keys(initialBreakpoints);
	// @ts-expect-error -- noImplicitAny: indexing by numeric key
	const deviceMap = devices.reduce((map, device, i) => ((map[i] = device), map), {});

	const breakpoints: Breakpoint[] = [];

	devices.forEach((device, i) => {
		const deviceName = kebabCase(device);
		// @ts-expect-error -- noImplicitAny: indexing initialBreakpoints by dynamic key
		const deviceBreakpoints = initialBreakpoints[device];
		if (isRotateBreakpoint(deviceBreakpoints)) {
			const rotateDirections = Object.keys(deviceBreakpoints);
			rotateDirections.forEach(direction =>
				// @ts-expect-error -- noImplicitAny: indexing deviceBreakpoints by dynamic key
				breakpoints.push({ name: `${deviceName}-${direction}`, value: deviceBreakpoints[direction] }),
			);
		} else {
			breakpoints.push({ name: deviceName, value: deviceBreakpoints });
		}

		// @ts-expect-error -- noImplicitAny: indexing by numeric key
		const nextDevice = devices.length >= i + 1 ? deviceMap[i + 1] : null;
		if (nextDevice) {
			// @ts-expect-error -- noImplicitAny: indexing initialBreakpoints by dynamic key
			const nextDeviceBreakpoints = initialBreakpoints[nextDevice];
			const nextSmallestBreakpoint = isRotateBreakpoint(nextDeviceBreakpoints)
				? Math.min(...Object.values(nextDeviceBreakpoints).filter(isNumber))
				: nextDeviceBreakpoints;

			if (isRotateBreakpoint(deviceBreakpoints)) {
				const rotateDirections = Object.keys(deviceBreakpoints);
				rotateDirections.forEach((direction, i) => {
					breakpoints.push({
						name: `${deviceName}-${direction}-max`,
						value:
							i === rotateDirections.length - 1
								? nextSmallestBreakpoint - 1
								: // @ts-expect-error -- noImplicitAny: indexing by dynamic key
									deviceBreakpoints[rotateDirections[i + 1]] - 1,
					});
				});
			} else {
				breakpoints.push({ name: `${deviceName}-max`, value: nextSmallestBreakpoint - 1 });
			}
		}
	});

	return (
		breakpoints
			.sort((a, b) => a.value - b.value)
			.map(b => ({ ...b, value: `${b.value}px` }))
			// @ts-expect-error -- noImplicitAny: reduce accumulator
			.reduce((breakpoints, breakpoint) => ((breakpoints[breakpoint.name] = breakpoint.value), breakpoints), {})
	);
}
